/**
 * AI Photos CTA Updater
 *
 * Updates the CTA button URL when the variant changes.
 * Listens for variant:changed events and updates the href with the new config.
 */

class AiPhotosCTAUpdater {
  constructor() {
    this.ctaButton = document.querySelector('[data-ai-photos-cta]');
    if (!this.ctaButton) return;

    this.baseUrl = this.extractBaseUrl(this.ctaButton.href);
    this.variantConfigs = this.loadVariantConfigs();
    this.bindEvents();
  }

  extractBaseUrl(href) {
    // Extract the base URL (pathname only, without query params)
    // e.g., /a/gallery-wall/product/product-handle
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname;
    } catch {
      return href.split('?')[0];
    }
  }

  loadVariantConfigs() {
    const configScript = document.getElementById('ai-photos-variant-configs');
    if (!configScript) return {};

    try {
      return JSON.parse(configScript.textContent);
    } catch (e) {
      console.error('[AI Photos] Failed to parse variant configs:', e);
      return {};
    }
  }

  bindEvents() {
    // Listen for variant changes from the variant picker
    document.addEventListener('variant:changed', (event) => {
      this.handleVariantChange(event.detail);
    });
  }

  handleVariantChange(detail) {
    if (!detail?.variant?.id) return;

    const variantId = detail.variant.id.toString();
    const configHandle = this.variantConfigs[variantId];

    this.updateCtaUrl(configHandle);
  }

  updateCtaUrl(configHandle) {
    if (!this.ctaButton) return;

    const params = new URLSearchParams();
    params.set('mode', 'ai_photos');
    if (configHandle) {
      params.set('config', configHandle);
    }

    this.ctaButton.href = `${this.baseUrl}?${params.toString()}`;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new AiPhotosCTAUpdater());
} else {
  new AiPhotosCTAUpdater();
}

export { AiPhotosCTAUpdater };
